import { Link } from "@inertiajs/react"

interface LogoProps {
  href?: string
  showText?: boolean
  className?: string
  iconSize?: "sm" | "md" | "lg"
}

const iconSizes = {
  sm: "h-6",
  md: "h-10",
  lg: "h-14",
}

export function Logo({
  href = "/",
  showText = true,
  className = "",
  iconSize = "md",
}: LogoProps) {
  const content = (
    <span className={`flex items-center ${className}`}>
      {showText && (
        <span className="text-brand font-brand text-xl font-semibold">
          Stitch
        </span>
      )}
      <img
        src="/logo.png"
        alt="Stitch logo"
        className={`${iconSizes[iconSize]} dark:hidden`}
      />
      <img
        src="/logo-dark.png"
        alt="Stitch logo"
        className={`${iconSizes[iconSize]} hidden dark:block`}
      />
    </span>
  )

  if (href) {
    return <Link href={href}>{content}</Link>
  }

  return content
}
